import { useContext, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Dropdown } from 'common/Dropdown/Dropdown'
import { Link } from 'react-router-dom'

import Styles from './DocObservers.module.scss'

import { DocPresenceContext } from 'stores/DocPresence'
import { ReactComponent as WatchIcon } from './icons/watch.svg'
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down__12.svg'
import { getPresenceUserPath, PresenceAvatar } from 'common/PresenceAvatars/PresenceAvatars'
import { consolidatedUserId } from 'common/PresenceAvatars/consolidatedUserId'

export const DocObservers = observer(() => {
  const docPresenceState = useContext(DocPresenceContext)

  const users = useMemo(() => {
    return docPresenceState?.followedBy.filter((user) => !!user) || []
  }, [docPresenceState?.followedBy])

  const renderDropdown = () => {
    return (
      <div className={Styles.dropdownContainer}>
        {users.map((user) => {
          if (!user) return null
          return (
            <Link to={getPresenceUserPath(user)} key={consolidatedUserId(user)}>
              <div className={Styles.userRow}>
                <PresenceAvatar color={undefined} user={user} seed={consolidatedUserId(user)} />
                <div className={Styles.userRowName}>
                  {user.first_name} {user.last_name}
                </div>
              </div>
            </Link>
          )
        })}
      </div>
    )
  }

  if (!users.length) return null

  return (
    <Dropdown
      trigger={
        <div className={Styles.container}>
          <WatchIcon className={Styles.watchIcon} />
          {users.length} {users.length > 1 ? 'people' : 'person'} observing you
          <ChevronDown className={Styles.chevronIcon} />
        </div>
      }
    >
      {renderDropdown()}
    </Dropdown>
  )
})
